<template>

  <div>
    <h2 class="title">注册信息</h2>
    <van-form style="padding-bottom:80px;">
      <van-field v-model="baiscData.phone" readonly name="手机号码" label="手机号码" />
      <van-field v-model="baiscData.name" readonly name="真实姓名" label="真实姓名" />
      <van-field v-model="baiscData.idCardTypeName" readonly name="证件类型" label="证件类型" />
      <van-field v-model="baiscData.idNo" readonly name="身份证" label="身份证" />
      <van-field v-model="baiscData.organization" readonly name="公司名称" label="公司名称" />
      <van-field v-model="baiscData.department" readonly name="部门" label="部门" />
      <van-field v-model="baiscData.position" readonly name="职位" label="职位" />
      <van-field v-model="baiscData.email" readonly name="电子邮箱" label="电子邮箱" />

      <template v-for="(item,index) in baiscData.attentFormDtoList">
        <van-field v-model="item.formContent" autosize type="textarea" readonly name="电子邮箱" :label="item.formTitle" :key="index" />
      </template>
    </van-form>

    <div style="position:fixed;bottom:0;width:100%;height:50px;background:#fff;display:flex;justify-content:space-between;padding: 0 30px;" v-if="isShow">
      <van-button type="primary" round style="width:45%" @click="confirmAccept()">审核通过</van-button>
      <van-button type="danger" round style="width:45%" @click="refuseReason()">审核驳回</van-button>
    </div>

    <!-- 用户列表 -->

    <van-dialog v-model="show" title="审核驳回" show-cancel-button @confirm='confirmRefuse' :lock-scroll='false'>
      <van-field v-model="reason" rows="2" autosize label="理由" type="textarea" maxlength="100" placeholder="请输入留言" show-word-limit />
    </van-dialog>

  </div>

</template>


<script>
import { registerUserDetail, auditUserSign } from '../../api/visitorRegisterApi'
import { GetQueryString } from '@/utils/utils'
export default {
  name: 'examineUserDetail',
  props: {},
  data() {
    return {
      baiscData: {},
      cardType: [
        {
          name: '身份证',
          key: 'CERTIFICATES_TYPE_1',
        },
        {
          name: '港澳居民来往内地通行证',
          key: 'CERTIFICATES_TYPE_2',
        },
        {
          name: '台湾居民来往大陆通行证',
          key: 'CERTIFICATES_TYPE_3',
        },
        {
          name: '外国人永久居住证',
          key: 'CERTIFICATES_TYPE_4',
        },
        {
          name: '护照',
          key: 'CERTIFICATES_TYPE_5',
        },
        {
          name: '其他',
          key: 'CERTIFICATES_TYPE_99',
        },
      ],
      show: false,
      reason: '',
      isShow: false,
    }
  },
  created() {
    this.audienceUid = GetQueryString('audienceUid')
    this.token = GetQueryString('token')
    this.status = GetQueryString('status')
    this.isShow = this.status == 'PENDING_REVIEW' ? true : false
    this.getDetail(this.audienceUid)
  },
  methods: {
    getDetail(audienceUid) {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: 'WX_MINI_MEHZ' }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
      }
      registerUserDetail(headers, 'EX1520295848969838592', audienceUid).then((res) => {
        console.log(res)
        this.baiscData = res.data
        this.baiscData.attentFormDtoList.forEach((v) => {
          // console.log(v, JSON.parse(v.formContent))
          if (v.formContent.indexOf('[') > -1) {
            v.formContent = JSON.parse(v.formContent).join(',')
          }
          if (v.formTitle == '性别') {
            v.formContent = v.formContent == 2 ? '女' : '男'
          }
        })
        this.baiscData.idCardTypeName = this.cardType.filter((v) => v.key == this.baiscData.idType)[0].name
      })
    },

    confirmAccept() {
      this.auditUserSign(this.baiscData, 'ACCEPT')
    },
    refuseReason() {
      this.show = true
    },
    confirmRefuse() {
      this.auditUserSign(this.baiscData, 'REFUSE')
    },
    auditUserSign(item, status) {
      var headerClientInfo = { language: 'CN', eventKey: 'MEHZ', appKey: "WX_MINI_MEHZ" }
      let headers = {
        'x-call-client-info': JSON.stringify(headerClientInfo),
        Authorization: this.token,
      }
      const data = {
        audienceUid: item.audienceUid,
        auditStatus: status,
        meetingCode: "EX1520295848969838592",
        reason: status == 'ACCEPT' ? '' : this.reason,
      }
      console.log(data)
      auditUserSign(headers, data).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.$toast.success('操作成功')
          this.isShow = false
        } else {
          this.$toast.fail(res.msg)
          this.isShow = false
        }
      })
    },
  },
}
</script>


<style lang="less" scoped>
.title {
  font-size: 14px;
  line-height: 16px;
  padding: 20px 16px 16px;
  text-align: left;
}
</style>